export const SET_BIRTHDAYS = `home/set_birthdays`;
export const SET_PROMOTIONS = `home/set_promotions`;
export const SET_REGISTRATION = `home/set_registration`;



// WEBPACK FOOTER //
// ./src/store/home/types.js